import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"

export default function FGHSignUpTreat() {
  const navigate = useNavigate()
  const data = promotionsData.find(
    (promo) => promo.title === "FGH Sign-Up Treat"
  )

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>FGH Sign-Up Treat</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>
                  FGH Sign-Up Treat: Up to 150,000 Total Free Spins on JILI
                  Slots!
                </h1>
                <h2>
                  Sign up at FGH & Get 50 FREE SPINS on JILI Slots! No deposit,
                  just fun!
                </h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>July 7 (12 NN) - Aug 6 (12 NN), 2025</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>Welcome New FGH Players! Here’s How to Join:</strong>

                <ol>
                  <li>
                    <p>
                      Search <strong className="highlight">FGH</strong> on
                      Google & register an FGH account during the promo period.
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong className="highlight">
                        First 100 Players Daily
                      </strong>{" "}
                      will automatically receive{" "}
                      <strong className="highlight">50 FREE SPINS</strong> on
                      any selected JILI Slots below:
                    </p>

                    <MasterGamesList
                      featuredGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customFeaturedGames={[
                        { provider: "jili", gameName: "Ali Baba" },
                        { provider: "jili", gameName: "Pirate Queen 2" },
                        { provider: "jili", gameName: "Super Ace" },
                        { provider: "jili", gameName: "Super Ace Deluxe" },
                        { provider: "jili", gameName: "Charge Buffalo" },
                        { provider: "jili", gameName: "Fortune Gems 2" },
                        { provider: "jili", gameName: "Golden Empire" },
                        { provider: "jili", gameName: "Money Pot" },
                        { provider: "jili", gameName: "3 Lucky Piggy" },
                        { provider: "jili", gameName: "Fortune Coins" },
                        { provider: "jili", gameName: "Feng Shen" },
                        { provider: "jili", gameName: "Bubble Beauty" },
                        { provider: "jili", gameName: "3 Pot Dragons" },
                        { provider: "jili", gameName: "Boxing King" },
                        { provider: "jili", gameName: "Bangla Beauty" },
                        { provider: "jili", gameName: "Bao Boon Chin" },
                        { provider: "jili", gameName: "Magic Lamp" },
                        { provider: "jili", gameName: "Golden Bank" },
                        { provider: "jili", gameName: "Jungle King" },
                        { provider: "jili", gameName: "3 Charge Buffalo" },
                      ]}
                      rank="on"
                      limit={20}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  </li>
                </ol>

                <ol start={3}>
                  <li>
                    <p>
                      <strong className="highlight">
                        Winnings from Free Spins
                      </strong>{" "}
                      will be credited to your{" "}
                      <strong className="highlight">Spin Bonus Wallet</strong>{" "}
                      and are subject to a{" "}
                      <strong className="highlight">30x wagering</strong>{" "}
                      requirement before they can be converted to real money or
                      withdrawn.
                    </p>
                  </li>
                  <li>
                    <strong className="highlight">Real money balance</strong> is
                    required to complete the rollover. Bonuses from free spins
                    cannot be withdrawn directly unless the wagering is
                    fulfilled.
                  </li>
                  <li>
                    <p>
                      One account per player only. Duplicate or Shared User/IP
                      will result in disqualification and will not receive any
                      free spins.
                    </p>
                  </li>
                  <li>
                    <p>Daily Cut off is 12NN to 11:59 AM next day.</p>
                  </li>
                  <li>
                    <p>
                      FGH Management reserves the right to modify or cancel this
                      promo at any time.
                    </p>
                  </li>
                </ol>

                <div className="promotion-tnc-cta">
                  <a className="promotion-cta-btn" href="/slots/?provider=JILI">
                    Play JILI Slots Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
